import { render, staticRenderFns } from "./Vettings.vue?vue&type=template&id=1209a4b6&scoped=true&"
import script from "./Vettings.vue?vue&type=script&lang=js&"
export * from "./Vettings.vue?vue&type=script&lang=js&"
import style0 from "./Vettings.vue?vue&type=style&index=0&id=1209a4b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1209a4b6",
  null
  
)

export default component.exports